// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".callout--GfSKF{background:#f0f0f3;border-radius:8px;padding:16px 20px;margin:0 16px 16px;position:relative}.title--oOrqi{font-weight:700;margin-bottom:4px}.body--l2xwM{color:#444;line-height:1.5}.body--l2xwM a{color:#6c5ce7;font-weight:500}.dismiss--nyFAa{position:absolute;top:12px;right:12px;background:none;border:none;cursor:pointer;color:#888;font-size:18px;padding:0;line-height:1}.dismiss--nyFAa:hover{color:#444}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"callout": "callout--GfSKF",
	"title": "title--oOrqi",
	"body": "body--l2xwM",
	"dismiss": "dismiss--nyFAa"
};
export default ___CSS_LOADER_EXPORT___;
